import React from "react";

import svg from "../../assets/images/icons/end_flow.svg";

export const EndFlowIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "End Flow"}
    />
);
